/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:52:37
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-01 14:00:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/OrderDetail/PickAndPack/Components/Card/Components/Row/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import {
  //GlobalTooltip,
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

const Item = (props) => {
  const { title, content } = props;
  return (
    <div className={css.itemContainer}>
      <NoWrapContainer className={css.titleContainer}>{title}</NoWrapContainer>

      <NoWrapContainer className={css.contentContainer}>
        {content}
      </NoWrapContainer>
    </div>
  );
};

const Row = (props) => {
  const { options } = props;
  return (
    <div className={css.container}>
      {(options || []).map((o, index) => {
        const { title, content } = o;
        return <Item title={title} content={content} key={index} />;
      })}
    </div>
  );
};
export default Row;
